import styled from 'styled-components';
import { Banner, Container } from '@tryhackme/thm-ui-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { ReactComponent as CheckList } from 'src/images/svgs/manage-room/check-list.svg';

export const StyledLeaderboardsContainer = styled(Container)`
  padding-top: 3rem;
`;

export const StyledBanner = styled(Banner)`
  padding: 0 1.2rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    height: 27.5rem;
  }
`;

export const StyledWrapperFilters = styled.div`
  display: block;
  margin-bottom: 2.4rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    margin-bottom: 2.4rem;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    align-items: center;
    display: flex;
    justify-content: flex-end;
  }
`;

export const StyledFilters = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  column-gap: 0.5rem;
  align-items: center;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto;
    row-gap: 5px;
    text-align: left;
  }
`;

export const StyledError = styled.div`
  margin-top: 8rem;
  text-align: center;
`;

export const StyledDropDown = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    margin-top: 1rem;
  }
`;

export const StyledSize = styled.span`
  margin-right: 1rem;
  margin-left: 1rem;
  font-size: large;
  color: ${({ theme }) => theme.colors.text.main};
`;

export const StyledSelect = styled.div`
  display: inline-block;
  vertical-align: middle;
  max-width: 8rem;
  width: 100%;
  text-align: left;
`;

export const StyledNoRecordMessage = styled.p`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.colors.grey[900]};
  background: #1153e41a;
  padding: 18px;
  border-radius: 5px;
  color: ${({ theme }) => theme.colors.paragraph};
  span {
    color: ${({ theme }) => theme.colors.info.main};
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  margin-top: 2.4rem;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    justify-content: center;
    gap: 2.4rem;
  }
`;

export const StyledText = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  color: ${({ theme }) => theme.colors.text.lighter};
`;

export const StyledPaginatedTableWrapper = styled.div`
  div[role='cell']:has(img) {
    @media (min-width: ${({ theme }) => theme.sizes.md}) {
      padding: 0.5rem 1.6rem;
    }
  }

  div[role='rowgroup'] {
    margin-bottom: 0;
  }

  div[role='table'] {
    box-shadow: 0px 3px 13px 0px #151c2b12;
    overflow: unset;
    border: 0.1rem solid ${({ theme }) => theme.colors.border.main};
    border-radius: ${({ theme }) => theme.radius.small};
    @media (max-width: ${({ theme }) => theme.sizes.md}) {
      box-shadow: none;
    }
  }
  div[role='cell'] {
    @media (max-width: ${({ theme }) => theme.sizes.md}) {
      padding: 1rem;

      > div {
        flex: 1;
        :first-child {
          display: flex;
          align-items: center;
          margin-right: 1rem;
          flex: 0 1 40%;
        }
      }
    }
  }
  div[role='row'] {
    transition: background-color 0.2s linear;
    position: relative;
    padding: 3rem 0.5rem;
    @media (max-width: ${({ theme }) => theme.sizes.md}) {
      border: none;
      :not(:first-child) {
        border-top: 0.1rem solid ${({ theme }) => theme.colors.border.light};
      }
      :first-child:has(div[role='cell']) {
        border-top-right-radius: ${({ theme }) => theme.radius.small};
        border-top-left-radius: ${({ theme }) => theme.radius.small};
      }
    }
    @media (min-width: ${({ theme }) => theme.sizes.md}) {
      padding: 0;
      :first-child:has(div[role='columnheader']) {
        border-top-right-radius: ${({ theme }) => theme.radius.small};
        border-top-left-radius: ${({ theme }) => theme.radius.small};
      }
    }
    :last-child:has(div[role='cell']) {
      border-bottom-right-radius: ${({ theme }) => theme.radius.small};
      border-bottom-left-radius: ${({ theme }) => theme.radius.small};
    }
  }
`;

export const StyledLinkContainer = styled.a`
  display: flex;
  align-items: center;
  gap: 0.8rem;
`;

export const StyledIcon = styled(FontAwesomeIcon)`
  & {
    color: ${({ theme }) => theme.colors.info.main};
  }
`;

export const StyledActionContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
`;

export const ActionStyledIcon = styled(FontAwesomeIcon)`
  background: transparent;
  padding: 1rem;
  &:hover,
  &:focus {
    color: red;
    cursor: pointer;
    border-radius: 5px;
    background: white;
  }
`;

export const StyledSvgImg = styled(CheckList)`
  &:hover path {
    fill: #1153e4;
  }
`;
